import theme from './landing.theme.json';

export type LandingVisualTheme = typeof theme;

/** Single source for landing Phase 2 palette (also loaded in tailwind.config.js). */
export const LANDING_VISUAL_THEME: LandingVisualTheme = theme;
